import React from 'react';
import Type from 'prop-types';
import { Button, Grid, List, ListSubheader } from '@mui/material';
import { t } from 'utils/i18n';
import styles from './FilterList.module.css';

const FilterList = (props) => {
  const { header, subheader, children, onFilterReset } = props;

  const renderSubheader = () => {
    return (
      <ListSubheader>
        <Grid container justifyContent="space-between">
          <Grid item>{header}</Grid>
          <Grid item>
            <Button
              color="primary"
              classes={{ text: styles.resetButton }}
              onClick={onFilterReset}
              data-testid="filterPopupResetBtn"
            >
              {subheader}
            </Button>
          </Grid>
        </Grid>
      </ListSubheader>
    );
  };

  return <List subheader={renderSubheader()}>{children}</List>;
};

FilterList.propTypes = {
  header: Type.string.isRequired,
  subheader: Type.string,
  children: Type.node.isRequired,
  onFilterReset: Type.func.isRequired,
};

FilterList.defaultProps = {
  subheader: t('reset'),
};

export default FilterList;
